module.exports = __webpack_public_path__ + "img/hipercard.37a54213.svg";